export default {"src":"/_next/static/media/pf.97c35ba6.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};